import styled from 'styled-components';

import Text from 'relements/build/esm/ui/text';
import Box from 'relements/build/esm/ui/box';

const ContainerStyle = (props) => ({
  border: `1px solid ${props.theme.colors.grey.haptik}`,
  padding: 2 * props.theme.space.sm,
  borderRadius: props.theme.space.xs,
  alignItems: 'center',
  width: '100%',
  background: props.theme.colors.grey.pastel,
  boxSizing: 'border-box',
  maxWidth: '500px',
  ':hover': {
    border: `1px solid ${props.theme.colors.blue.haptik}`,
    cursor: 'pointer',
  },
});
export const Container = styled(Box)(ContainerStyle);

const TitleStyle = (props) => ({
  marginLeft: props.theme.space.md,
});
export const Title = styled(Text)(TitleStyle);

const EnabledBoxStyle = ({ theme }) => ({
  border: 'none',
  backgroundColor: theme.colors.green.pastel,
  padding: '4px 12px',
  borderRadius: '10px',
});

export const EnabledBox = styled(Box)(EnabledBoxStyle);

const EnabledTextStyle = ({ theme }) => ({
  color: theme.colors.green.haptik,
});

export const EnabledText = styled(Text)(EnabledTextStyle);
